// Firebase configuration for NM Rebuild
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCD4J6V_cA8IIHWsMcT4Yc1S5kTDKI9PYI",
  authDomain: "nm-rebuild.firebaseapp.com",
  projectId: "nm-rebuild",
  storageBucket: "nm-rebuild.firebasestorage.app",
  messagingSenderId: "193594931795",
  appId: "1:193594931795:web:1edb48c077d1c1e0c1a4a6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
